import { Table } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { P1P2Contenxt } from "../..";

const P2DailyTable = () => {
  const { dataSource } = useContext(P1P2Contenxt);

  const [filtredDataSet, setFiltredDataSet] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (
      dataSource &&
      dataSource["P2"] &&
      !dataSource["P2"].loading &&
      dataSource["P2"].data.list
    ) {
      if (dataSource["P2"].data.list && dataSource["P2"].data.list.length > 0) {
        setFiltredDataSet(dataSource["P2"].data.list);

        let tmpColumns = [];
        const { _id, read, __v, enable, ...row } =
          dataSource["P2"].data.list[0];
        const rows = Object.keys(row);
        rows.forEach((key) =>
          tmpColumns.push({
            key: key,
            title: key,
            dataIndex: key,
            className: "whitespace-nowrap",
          })
        );
        setColumns([...tmpColumns]);
      }
    }
  }, [dataSource]);

  const handleChange = (pagination, filters, sorter, { currentDataSource }) => {
    setFiltredDataSet(currentDataSource);
  };

  return (
    <div className="pt-0 border">
      <Table
        scroll={{ scrollToFirstRowOnChange: true, x: "480px" }}
        onChange={handleChange}
        dataSource={[...filtredDataSet]}
        loading={dataSource["P2"].loading}
        columns={[...columns]}
        rowKey="_id"
        size="small"
        pagination={false}
        // bordered
      />
    </div>
  );
};

export default P2DailyTable;
